/**
 * Shared data-view preference (grid vs card) for every WorkSched ag-grid page.
 *
 * A single reactive singleton so all <WsGrid> instances stay in sync on the
 * same page and the choice persists across navigation/reloads via localStorage.
 * Below the mobile breakpoint card view is always forced (a dense grid is
 * unusable on phones); the toggle still controls desktop and is remembered.
 */
import { reactive } from "vue";

const STORAGE_KEY = "worksched.dataView";
const MOBILE_BREAKPOINT = 768;

function readStored() {
  try {
    return localStorage.getItem(STORAGE_KEY) === "card" ? "card" : "grid";
  } catch (e) {
    return "grid";
  }
}

export const dataView = reactive({
  mode: readStored(),
  isMobile: typeof window !== "undefined" ? window.innerWidth < MOBILE_BREAKPOINT : false,
});

export function setDataView(mode) {
  dataView.mode = mode === "card" ? "card" : "grid";
  try {
    localStorage.setItem(STORAGE_KEY, dataView.mode);
  } catch (e) {
    /* storage unavailable — keep in-memory only */
  }
}

if (typeof window !== "undefined") {
  let timer;
  window.addEventListener("resize", () => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      dataView.isMobile = window.innerWidth < MOBILE_BREAKPOINT;
    }, 150);
  });
}
